import styled from 'styled-components';
import {
    StrategyPageHeader,
    StrategyWideCardColumn,
    StrategyProductCard,
} from '../../Strategy/styles';

/** Card do relatório sem margin-bottom extra (empilhados com gap no stack) */
export const TradingReportCard = styled(StrategyProductCard)`
    margin-bottom: 0 !important;
`;

/** Empilha o card de filtro e o card de métricas/tabela */
export const TradingReportCardsStack = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;

    @media (min-width: 768px) {
        gap: 28px;
    }
`;

export const TradingReportStack = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: stretch;
    gap: 44px;

    @media (min-width: 768px) {
        gap: 60px;
    }
`;

export const TradingPageHeader = styled(StrategyPageHeader)`
    margin-bottom: 0 !important;
`;

export const TradingWideCardColumn = styled(StrategyWideCardColumn)`
    margin-top: 0 !important;
`;

export const FilterSection = styled.div`
    margin-bottom: 0;
`;

export const FilterTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: rgba(200, 210, 235, 0.9);
    margin-bottom: 16px;

    i {
        color: #f29205;
    }
`;

export const FilterRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 16px 20px;
`;

export const FilterField = styled.div`
    flex: 1 1 200px;
    min-width: 160px;
    max-width: 280px;

    .MuiFormControl-root {
        width: 100%;
    }
`;

export const FilterActions = styled.div`
    flex: 0 0 auto;
    display: flex;
    align-items: stretch;
    align-self: flex-end;

    .MuiButton-root {
        min-height: 48px !important;
        height: 48px !important;
        padding: 0 22px !important;
        box-sizing: border-box !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
    }

    @media (min-width: 768px) {
        .MuiButton-root {
            min-height: 52px !important;
            height: 52px !important;
        }
    }

    @media (min-width: 992px) {
        .MuiButton-root {
            min-height: 56px !important;
            height: 56px !important;
        }
    }
`;

export const PageInner = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;

    .MuiOutlinedInput-root fieldset {
        border-width: 1px !important;
        border-color: rgba(242, 146, 5, 0.32) !important;
    }

    .MuiOutlinedInput-root:hover fieldset {
        border-color: rgba(242, 146, 5, 0.5) !important;
    }

    .MuiOutlinedInput-root.Mui-focused fieldset {
        border-color: #00d4ff !important;
    }
`;

/** Agrupamento lógico dos cards (vitórias / derrotas / resumo) */
export const MetricsSectionsStack = styled.div`
    display: flex;
    flex-direction: column;
    gap: 28px;
    width: 100%;
    margin-top: 0;

    @media (min-width: 768px) {
        gap: 32px;
    }
`;

export const MetricsSection = styled.section`
    width: 100%;
    margin: 0;
    padding: 0;
`;

export const MetricsSectionTitle = styled.h2`
    margin: 0 0 14px 0;
    padding: 0;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: rgba(200, 210, 235, 0.88);
`;

export const calcPrimaryButtonStyle = {
    background: 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)',
    border: 'none',
    color: '#ffffff',
    padding: '0 22px',
    borderRadius: '10px',
    fontWeight: 600,
    fontSize: 14,
    boxShadow: '0 4px 15px rgba(242, 146, 5, 0.35)',
    minWidth: 120,
    textTransform: 'none',
    transition: 'all 0.25s ease',
};

/**
 * Resumo (2 cards): CSS Grid iguala altura das colunas na mesma linha.
 */
export const MetricsGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
    margin-top: 0;
    width: 100%;
    align-items: stretch;

    > * {
        min-width: 0;
        min-height: 0;
        display: flex;
        flex-direction: column;
        height: 100%;
        align-self: stretch;
    }

    @media (min-width: 900px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
`;

export const ReportTableBlock = styled.div`
    width: 100%;
    margin-top: 72px;
    padding-top: 0;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
`;
